var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeFeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Like"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M49.2862 5.16524C42.04 4.14718 35.5124 7.56069 32.039 13.0702C28.7153 7.77029 22.547 4.41666 15.6601 5.04547C7.36591 5.82399 0.718546 12.5312 0.0597986 20.7656C-0.239632 24.3887 0.598775 27.8022 2.27559 30.6767C2.48519 31.0959 2.78462 31.4553 3.08405 31.8146L5.95858 35.1383L6.19813 35.4077L30.3921 58.3741C31.2904 59.2424 32.7277 59.2424 33.626 58.3741L57.9996 35.2281L61.2934 31.4253C61.4431 31.1558 61.5928 30.9163 61.7425 30.6767C63.5391 27.5327 64.3775 23.7599 63.8385 19.8074C62.8205 12.2917 56.772 6.21325 49.1964 5.16524H49.2862Z",
    fill: "#44484E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeFeed);
export default __webpack_public_path__ + "static/media/LikeFeed.4c510deb430594f446cfe04bb61cc57a.svg";
export { ForwardRef as ReactComponent };